export default __webpack_public_path__ + "static/realWorldImage1-08301395894105e7e50019bbf3d58972.webp";